export default "__VITE_ASSET__CeOHNmz2__"